import styled, { css } from 'styled-components';

import { mediumMediaQuery, smallMediaQuery } from '../../../../common/utilities/sizeHelpers';

export const NoDataHeaderTextIconWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 32px;
`;

export const NoDataTextStyle  = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    font-family: Source Sans Pro;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    text-transform: capitalize;
    color: #333333;
`;

export const NoDataHeaderText = styled.div`
    ${NoDataTextStyle}
    margin-left: 10px;
`;

export const NoDataBodyText = styled.div`
    ${NoDataTextStyle}
    font-weight: normal;
    text-transform: none;
    margin-left: 42px;
`;

interface IconWrapperProps {
    isMapOrStoriesView?: boolean;
}
export const IconWrapper = styled.span<IconWrapperProps>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: ${({ isMapOrStoriesView }) => isMapOrStoriesView ? '32px' : '100%' };
`;

interface ContainerProps {
    isHealthAdvice?: boolean;
}
export const Container = styled.div<ContainerProps>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 12px 10px;
    width: 100%;
    height: 100%;
    @media ${mediumMediaQuery} {
        height: ${({ isHealthAdvice }) => isHealthAdvice ? '196px' : '288px' };
    }
    @media ${smallMediaQuery} {
        height: 100px;
    }
    background: #F9F9F9;
    border-radius: 0px 0px 2px 2px;
`;

export const MapStoriesViewNoDataHeaderTextIconWrapper = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 90px;
`;

export const MapStoriesViewNoDataHeaderText = styled.div`
    ${NoDataTextStyle}
    margin: 16px 0 0 0;
`;

export const MapStoriesViewNoDataBodyText = styled.div`
    ${NoDataTextStyle}
    font-weight: normal;
    text-transform: none;
    text-align: center;
    margin: 16px 0 0 0;
`;
